
import Vue from "vue";
export default Vue.extend({
	props: {
		skipOne: Boolean,
		value: {
			type: Number
		},
		maxShownPages: {
			type: Number
		},
		totalPages: {
			type: Number
		}
	},
	computed: {
		highestPageNumber(): number {
			return Math.ceil(this.totalPages);
		},
		toShowPages(): number[] {
			let pages = [this.value];
			let shownPages = () => pages.length;
			let halfPageCount = Math.round((this.maxShownPages - 1) / 2);
			if (this.value <= halfPageCount) {
				for (let i = this.value - 1; i > 0; i--) {
					pages.unshift(i);
				}
				for (let i = this.value + 1; i <= this.highestPageNumber; i++) {
					if (shownPages() >= this.maxShownPages) {
						break;
					}
					pages.push(i);
				}
				return pages;
			}
			if (this.value >= this.highestPageNumber - halfPageCount) {
				for (let i = this.value + 1; i <= this.highestPageNumber; i++) {
					if (this.value >= this.highestPageNumber) {
						break;
					}
					pages.push(i);
				}
				for (let i = this.value - 1; i >= 1; i--) {
					if (shownPages() >= this.maxShownPages) {
						break;
					}
					pages.unshift(i);
				}
				return pages;
			}
			for (let i = this.value - 1; this.value - i <= halfPageCount; i--) {
				pages.unshift(i);
			}
			for (let i = this.value + 1; i - this.value <= halfPageCount; i++) {
				pages.push(i);
			}
			return pages;
		}
	},
	methods: {
		onClick(page: number) {
			this.$emit("input", page);
		}
	}
});
